module.exports = __webpack_public_path__ + "a20eb5c6b8db34565c6788eb43f14c1d.pdf";